import { emitter } from '../../../util.js'

angular.module('pub.bundle.step4', ['pub.bundle.step4.react']).controller('Step4Ctrl', Step4Ctrl)

/** @ngInject */
function Step4Ctrl(
  $scope,
  $rootScope,
  $state,
  $q,
  $stateParams,
  CollectiblesService,
  SetsService,
  OddsService,
  BundleCache,
) {
  var vm = this
  vm.parentId = $stateParams.parentId
  vm.isEvent = $stateParams.event
  vm.isChannelBundle = !!$stateParams.channelId
  vm.channelId = $stateParams.channelId
  var sets = []
  var collectibles = []
  var odds = []
  var models = []
  vm.data = {
    s3: $rootScope.urlS3,
  }

  //start
  // load();

  //function bind
  vm.back = function () {
    if (vm.isEvent) {
      $state.go('admin.event')
      return
    }
    $state.go('pub.bundles', { parentId: $stateParams.parentId })
  }

  // vm.classDisabled = function(){
  //   for (var i = 0; i < collectibles.length; i++) {
  //     if (collectibles[i].progress === 4 && collectibles[i].tog === true){
  //       return;
  //     }
  //   }
  //   return 'is-disabled';
  // };

  vm.dataCollapse = function (index) {
    colapse(index, false, function () {})
  }

  vm.selectAll = function (index) {
    if (!vm.sets[index].colapse) {
      colapse(index, true, function () {
        saveAll(index)
      })
    } else {
      saveAll(index)
    }
  }

  vm.toogleChange = function (item, data, index) {
    var setDad = angular.copy(data)
    setDad.q = []
    item.tog === true ? add(item, setDad) : remove(item, setDad, index)
  }

  vm.save = function () {
    toastr.success('Saved!')
    if (vm.isEvent) {
      $state.go('pub.bundles.step5', {
        parentId: $stateParams.parentId,
        id: $stateParams.id,
        event: $stateParams.event,
        create: $stateParams.create,
        post: $stateParams.post,
      })
    }
  }

  //function pure
  function load() {
    SetsService.get($stateParams.parentId).then(function (responseSet) {
      var channelId = responseSet.results['id-ch']
      SetsService.getChannelId(channelId).then(success)

      function success(result) {
        sets = result.results
        for (var i = 0; i < sets.length; i++) {
          sets[i].o = 1
          sets[i].q = null
          sets[i].expand = false
          sets[i].colapse = false
          if (sets[i].id === parseInt($stateParams.parentId)) {
            sets.remove(sets[i])
            i > 0 ? (i -= 1) : (i = 0)
          }
        }

        vm.sets = sets
      }
    })
  }

  function colapse(index, isSelect, cb) {
    if (vm.sets[index].colapse && isSelect === false) {
      vm.sets[index].expand = false
      vm.sets[index].colapse = false
      return
    } else if (vm.sets[index].colapse && isSelect) {
      return
    }

    vm.sets[index].expand = true
    var id = sets[index].id
    var promises = {
      collectibles: CollectiblesService.getSetId(id),
      odds: OddsService.get($stateParams.id),
    }

    $q.all(promises).then(success)

    function success(result) {
      collectibles = result.collectibles.results
      odds = result.odds.results
      var len = collectibles.length
      var lenOdd = odds.length
      for (var i = 0; i < len; i++) {
        collectibles[i].o = 1
        collectibles[i].progress = 0
        collectibles[i].printCount = 0

        if (collectibles[i].t !== '') {
          collectibles[i].progress += 1
        }
        if (collectibles[i].e !== 0) {
          collectibles[i].progress += 1
        }
        if (collectibles[i].bc !== 0) {
          collectibles[i].progress += 1
        }
        if (collectibles[i]['img-t'] !== '') {
          collectibles[i].progress += 1
        }

        collectibles[i].printCount = collectibles[i].bc * window.Math.pow(collectibles[i].em, collectibles[i].e - 1)
        if (isNaN(collectibles[i].printCount)) {
          collectibles[i].printCount = 0
        }

        if (odds.length === 0) {
          collectibles[i].tog = false
        } else {
          for (var j = 0; j < lenOdd; j++) {
            if (collectibles[i].id === odds[j]['id-q']) {
              collectibles[i].tog = true
            }
          }
          if (collectibles[i].tog === undefined) {
            collectibles[i].tog = false
          }
        }
      }

      sets[index].q = collectibles
      vm.sets = sets
      vm.sets[index].expand = false
      vm.sets[index].colapse = !vm.sets[index].colapse
      cb()
    }
  }

  function saveAll(index) {
    for (var i = 0; i < vm.sets[index].q.length; i++) {
      if (vm.sets[index].q[i].tog === false) {
        vm.sets[index].q[i].tog = true
        var setDad = angular.copy(vm.sets[index])
        setDad.q = []
        if (vm.sets[index].q[i].tog) {
          add(vm.sets[index].q[i], setDad)
        }
        // vm.toogleChange(vm.sets[index].q[i], vm.sets[index]);
      }
    }

    if (models.length > 0) {
      OddsService.save(parseInt($stateParams.id), models).then(function () {
        toastr.success('Saved!')
      })
    }
  }

  function add(item, setDad) {
    var model = {
      'id-b': parseInt($stateParams.id),
      o: 1000,
      'id-q': item.id,
      t: item.t,
      'img-t': item['img-t'],
      cr: item.cr,
    }

    if (odds.length === 0) {
      setDad.q.push(model)
      models.push(model)
      refreshOdds(setDad)
      return
    }

    var len = odds.length
    for (var i = 0; i < len; i++) {
      if (odds[i]['id-q'] !== item.id) {
        setDad.q.push(model)
        models.push(model)
        refreshOdds(setDad)
        return
      }
    }
  }

  function remove(item, setDad, index) {
    var itemDelete
    var len = odds.length
    for (var i = 0; i < len; i++) {
      if (odds[i]['id-q'] === item.id) {
        itemDelete = odds[i]
        break
      }
    }

    if (itemDelete.id === undefined) {
      return
    }

    OddsService.deleteOdd(itemDelete.id).then(success, error)

    function success() {
      odds.remove(itemDelete)
      var oddsCorrect = []
      for (var i = 0; i < odds.length; i++) {
        if (odds[i].q['id-s'] === setDad.id) {
          oddsCorrect.push(odds[i])
        }
      }
      setDad.q = oddsCorrect
      refreshOddsDelete(setDad)
    }

    function error(result) {
      swal(result.error.message)
      item.tog = true
    }
  }

  function refreshOdds(set) {
    BundleCache.addOddsOtherSets(set)
  }

  function refreshOddsDelete(set) {
    BundleCache.removeOddsOtherSets(set)
  }

  vm.productType = null
  vm.edition = null
  vm.setType = null

  vm.productTypes = [
    { id: 1, name: 'Sticker' },
    { id: 2, name: 'Card' },
    { id: 3, name: 'Figure' },
  ]

  vm.editions = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
  ]

  vm.setTypes = [
    { id: 0, name: 'Standard' },
    { id: 1, name: 'Award' },
    { id: 2, name: 'Collectors Edition' },
  ]

  var watch1 = $scope.$watch('vm.productType', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: newVal,
      edition: vm.edition,
      setType: vm.setType,
    })
  })

  var watch2 = $scope.$watch('vm.edition', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: vm.productType,
      edition: newVal,
      setType: vm.setType,
    })
  })

  var watch3 = $scope.$watch('vm.setType', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: vm.productType,
      edition: vm.edition,
      setType: newVal,
    })
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
    watch3()
  })

  vm.showSoldOut = true
  vm.removeSoldOut = function () {
    emitter.emit('showSoldOut', {
      status: vm.showSoldOut,
    })
  }
}
